import classnames from 'classnames';

import { getCursorClass } from 'Components/utils/form/form.util';

export const themes = {
  default: props => ({
    thInput: classnames('reset-input text-md sm:text-base w-full', getCursorClass(props), {
      'text-white': props.isFilled,
      'text-darker-gray': !props.isFilled,
      'button-medium': props.size === 'medium',
      'button-default': props.size === 'large',
    }),
    thToggler: classnames('reset-button leading-none px-4 text-base', getCursorClass(props)),
  }),
};
